import moment from 'moment';
import { routes } from '../constants/routes.constant';

export const isEmpty = val => {
    let empty = true;

    if (!val && val !== 0) {
        empty = true;
    }

    if (typeof val === 'number') {
        empty = false;
    }

    if (typeof val === 'string') {
        empty = !val.trim();
    }

    if (typeof val === 'object' && val) {
        empty = !Object.keys(val).length;
    }

    if (Array.isArray(val)) {
        empty = !val.length;
    }

    return empty;
};

export const returnPromise = data => {
    return Promise.resolve(data).then(results => {
        return results;
    }).catch(error => {
        throw error;
    });
};

export const dateToTst = date => {
    const result = new Date(date).getTime() / 1000;
    return result;
};

export const tstToDate = UNIX_timestamp => {
    const date = new Date(UNIX_timestamp * 1000);
    // const result = dateToMomentDate(date);
    return date;
};

export const dateToMomentDate = date => {
    // const result = moment(date).utc().toDate();
    return date;
};

export const tstToMomentDayOfWeek = UNIX_timestamp => {
    const date = new Date(UNIX_timestamp * 1000);
    let result = null;
    try {
        result = moment(date).utc().isoWeekday();
    } catch (err) {
        throw err;
    }

    switch (result) {
        case 1:
            return 'Mon';
        case 2:
            return 'Tue';
        case 3:
            return 'Wed';
        case 4:
            return 'Thu';
        case 5:
            return 'Fri';
        case 6:
            return 'Sat';
        case 7:
            return 'Sun';
        default:
            return 'not a week day';
    }
};

export const tstToMomentDate = (UNIX_timestamp, format) => {
    const date = tstToDate(UNIX_timestamp);
    let result = null;
    try {
        // result = moment(date).utc().format(format);
        result = moment(date).format(format);
    } catch (err) {
        throw err;
    }

    return result;
};

export const isCostUrl = currentUrl => {
    return !!~currentUrl.split('/').indexOf('cost');
};

export const isControlUrl = currentUrl => {
    return !!~currentUrl.split('/').indexOf('profile');
};

export const isFooterVisible = currentUrl => {
    return !!~[routes.home(), routes.deviceRaw(), routes.control(), routes.alert(), routes.more()].indexOf(currentUrl) || isCostUrl(currentUrl) || isControlUrl(currentUrl);
};

export const roundNumber = (number, maxLength = 3) => {
    if (!number || !maxLength) {
        return number;
    }

    const numberStr = number.toString();
    const length = numberStr.length;
    if (length <= maxLength) {
        return number;
    }

    var index = numberStr.indexOf('.');
    if (index < 0) {
        return number;
    }

    if (index > maxLength) {
        return parseFloat(new Big(number).round(0, 1));
    }

    var delta = maxLength - index;
    return parseFloat(new Big(number).round(delta, 1));
};

export const flatArray = array => {
    const result = Array.prototype.concat.apply([], array);
    return result;
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/utils/helpers.js